import * as React from "react";
import { Box, Center, Flex, Heading, Image, List, ListItem, Text } from "@chakra-ui/react";
import siteConfig from "configs/site-config";
import { Page, Section } from "components/page";

const Experience = () => {
  return (
    <Page title="Experience">
      {siteConfig.experience.map((job) => (
        <Section key={job.role} label={job.years}>
          <Flex align="center" gap={4}>
            <Center
              boxSize={12}
              flexShrink={0}
              p={1.5}
              bg="white"
              borderRadius="lg"
              border="1px solid"
              borderColor="line"
              overflow="hidden"
            >
              <Image src={job.img} alt="" maxW="full" maxH="full" objectFit="contain" />
            </Center>
            <Box>
              <Heading as="h2" fontSize={{ base: "2xl", md: "3xl" }} lineHeight={1.1}>
                {job.role}
              </Heading>
              <Text className="prose" color="muted" fontSize="md" mt={1}>
                {job.url ? <a href={job.url}>{job.org}</a> : job.org}
              </Text>
            </Box>
          </Flex>

          <List spacing={3} mt={6}>
            {job.sections.map((section, index) => (
              <ListItem key={index} display="flex" gap={4}>
                <Box flexShrink={0} w={3} h="1px" mt="0.85em" bg="accent" />
                <Text as="span">{section}</Text>
              </ListItem>
            ))}
          </List>
        </Section>
      ))}
    </Page>
  );
};

export default Experience;
